import useSWR, { KeyedMutator } from "swr";
import {
  TableInfo,
  EntityFieldsResponse,
  getEntityFields,
} from "../services/cleaning-data-service";

export interface UseAllTablesReturn {
  availableTables: TableInfo[] | undefined;
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<EntityFieldsResponse>;
}

const useAllTables = (): UseAllTablesReturn => {
  const { data, error, mutate } = useSWR("/fields/all", () =>
    getEntityFields(),
  );

  return {
    availableTables: data?.availableTables,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useAllTables;
